module.exports = __webpack_public_path__ + "assets/pre_en.60a79bd2f7bc0c67c158d2827d851c33.png";